import { Component, Event, EventEmitter, h, Listen, Prop } from '@stencil/core';
import { Producer } from '../../models/producer';
import { LANGUAGES } from '../../utils';

@Component({
  tag: 'single-producer-card',
  styleUrl: 'producer-card.scss',
  shadow: true,
})
export class SingleProducerCard {
  @Prop()
  language: keyof typeof LANGUAGES = 'de';

  @Prop()
  producer?: Producer;

  @Event()
  closeSingleProducerCard: EventEmitter;

  @Listen('close')
  closeCardHandler() {
    this.closeSingleProducerCard.emit();
  }

  render() {
    return (
      <mdx-modal heading={this.producer?.name} open={this.producer !== undefined}>
        {this.producer !== undefined && (
          <div class="producer-card" slot="content">
            <producer-content producer={this.producer} language={this.language} />
          </div>
        )}
      </mdx-modal>
    );
  }
}
